/* eslint-disable react/react-in-jsx-scope */
/*
 * File: LabConfigurationInput.tsx
 * Project: papa-bear
 * -----
 * Last Modified: 17 May 2021 2:18:12 pm
 * -----
 * Copyright (c) 2021 Elegant Software Solutions All rights reserved.
 */

import { Col, Radio, RadioChangeEvent, Row, Typography } from 'antd';
import { CreateSalesOrderType } from 'common/enums/CreateSalesOrderType';
import { useFormikContext } from 'formik';
import { InlineStylesModel } from 'models/InlineStylesModel';
import { SalesOrderPayloadModel } from 'models/SalesOrderPayloadModel';
import { useLocation } from 'react-router-dom';
const { Title } = Typography;

const styles: InlineStylesModel = {
  formItem: {
    marginBottom: 10
  },
  formItemCol: {
    marginRight: '16px',
    maxHeight: '42px'
  },
  titleColor: {
    color: '#2F5596',
    margin: 0,
    marginRight: 16
  },
  switchInput: {
    margin: '10px 0px'
  }
};

export const LabConfigurationInput = (): JSX.Element => {
  const {
    values: { labConfiguration },
    setFieldValue
  } = useFormikContext<SalesOrderPayloadModel>();
  const { pathname } = useLocation();
  const isPosted = pathname.includes('/posted');

  /* ****************** Functions ****************** */
  const handleSwitch = (event: RadioChangeEvent): void => {
    setFieldValue('labConfiguration' as keyof SalesOrderPayloadModel, event.target.value);
  };

  /* ****************** Render ****************** */
  return (
    <Row style={{ marginTop: 32 }} align="middle" gutter={[8, 8]}>
      <Col>
        <Title level={5} style={styles.titleColor}>
          {CreateSalesOrderType.LAB_CONFIGURATION}
        </Title>
      </Col>
      <Col>
        <Radio.Group disabled={isPosted} onChange={handleSwitch} buttonStyle="solid" defaultValue={labConfiguration}>
          <Radio.Button value={true}>Yes</Radio.Button>
          <Radio.Button value={false}>No</Radio.Button>
        </Radio.Group>
      </Col>
    </Row>
  );
};
